<sm-toolbar>
    <p-button icon="fas fa-cog" label="Tenant ID ermitteln" (onClick)="getTenantId()"></p-button>
    <p-button icon="fas fa-cog" label="URL ermitteln für Zugriffsfreigabe durch Benutzer" (onClick)="getAccessUrl()"></p-button>
</sm-toolbar>
